<template>
	<v-container fluid grid-list-lg class="pa-3">
		<v-form ref="MainForm" lazy-validation v-model="form_valid">
			<v-layout row wrap>
				<v-flex class="pt-0">
					<v-card>
						<v-tabs v-model="tabs.active" color="#9ec8c8" slider-color="secondary">
							<v-tab ripple>Info</v-tab>
							<v-tab ripple>others</v-tab>

							<v-tab-item>
								<v-card flat>
									<v-card-text>
										<v-layout row wrap>
											<v-flex xs12 md6 pa-2 class="dull">
												<v-container grid-list-md class="pa-2">
													<v-layout row wrap>
														<v-flex xs12>
															<v-text-field
																readonly
																:value="selected._id"
																label="#ID"
															></v-text-field>
														</v-flex>
														<v-flex xs12>
															<v-text-field
																readonly
																:value="selected.label"
																label="Label"
															></v-text-field>
														</v-flex>
														<v-flex xs12>
															<v-select
																readonly
																:items="status_option"
																v-model="selected.g_status_id"
																item-text="label"
																item-value="_id"
																label="Status"
															></v-select>
														</v-flex>
														<v-flex xs12>
															<v-text-field
																readonly
																:value="selected.created_by"
																:messages="epoch2localedatetime(selected.created)"
																label="Created By"
															></v-text-field>
														</v-flex>
														<v-flex xs12>
															<v-text-field
																readonly
																:value="selected.modified_by"
																:messages="epoch2localedatetime(selected.modified)"
																label="Last Modified By"
															></v-text-field>
														</v-flex>
													</v-layout>
												</v-container>
											</v-flex>
											<v-flex xs12 md6 pa-2>
												<v-container grid-list-md class="pa-2">
													<v-layout row wrap>
														<v-flex xs12>
															<v-select
																:readonly="getCurrentStatusOrder(selected.g_status_id)>1"
																:rules="[rules.required]"
																:items="type_option"
																v-model="selected.g_type_id"
																item-text="label"
																item-value="_id"
																label="Type"
															></v-select>
														</v-flex>
														<v-flex xs12>
															<v-text-field
																:readonly="getCurrentStatusOrder(selected.g_status_id)>1"
																v-model="selected.description"
																label="Description"
															></v-text-field>
														</v-flex>
														<v-flex xs12>
															<v-textarea
																:readonly="getCurrentStatusOrder(selected.g_status_id)>1"
																v-model="selected.remark"
																label="Remark"
																hint="Max 1000 characters."
															></v-textarea>
														</v-flex>
													</v-layout>
												</v-container>
											</v-flex>
										</v-layout>
									</v-card-text>
								</v-card>
							</v-tab-item>

							<v-tab-item>
								<events_page_btrt
									:showItemsM.sync = "comp_membersList"
									:showItemsC.sync = "comp_collaboratorsList"
									@newMember = "newMember($event)"
									@newColl = "newColl($event)"
								/>
							</v-tab-item>

						</v-tabs>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn outline color="orange" :href="'events_listing?uuid=3cf1c8fb-3010-4ccb-9fdc-5556d62111c7'">Cancel</v-btn>
							<v-btn outline color="blue" :href="'events_btrt?uuid=543b1e24-11c8-4178-95a7-84b25968328e&_id=' + selected._id" v-if="getCurrentStatusOrder(selected.g_status_id)>=2">Assessment</v-btn>
							<v-btn dark color="blue"
								@click="setActive_onClick()"
								v-if="selected.g_status_id==(status_option[0]?status_option[0]._id:true) && selected._id"
							>Set Active</v-btn>

							<v-btn dark color="blue"
								@click="setInactive_onClick()"
								v-if="getCurrentStatusOrder(selected.g_status_id)==2"
							>Set Inactive</v-btn>

							<v-btn dark color="green"
								@click="onClick_save()"
								v-if="getCurrentStatusOrder(selected.g_status_id)<2"
							>Save</v-btn>

							<v-btn dark color="green"
								@click="onClick_save(true)"
								v-if="getCurrentStatusOrder(selected.g_status_id)==2"
							>Update Collaborator</v-btn>
						</v-card-actions>
					</v-card>
				</v-flex>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
import auth from "../../functions/auth";
import common from "../../functions/general";
import qb from "../../functions/query.builder";
// import ListGroup_Collaborator from "../../components/ListGroup_Collaborator";
// import ListGroup_Member_BTRT from "../../components/ListGroup_Member_BTRT";
import events_page_btrt from "./events_page_btrt";

export default {
  name: "events_crud",
  components: {
    // ListGroup_Collaborator: ListGroup_Collaborator,
		// ListGroup_Member_BTRT: ListGroup_Member_BTRT,
		events_page_btrt: events_page_btrt
  },
  data() {
    return {
      // pageid: "",
			pageUUID: "",
      username: "",
			form_valid: true,
      tabs: {
        active: 0,
      },
      rules: {
        required: (value) => !!value || "This field required.",
        greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
      },
			status_option: [],
			type_option: [],
      selected: {
				_id: "",
				label: "",
				remark: "",
				description: "",
				g_status_id: "",
				g_type_id: "",
				data: {},
				collaborators: [],
				created: "",
				created_by: "",
				modified: "",
				modified_by: ""
			},
			event_type: "",
			// optionList: [],
			membersList: [],
			collaboratorsList: [],
			freezedSelected: {},
			auth_role_list: [],
			auth_role: false,
			user_event_role: [],
    };
  },
  watch: {},
  async mounted() {
		common.App.loader.show(this);

    common.App.set_page_title("mySuite : BTRT");
    // this.pageid = common.App.get_pageID();
		this.pageUUID = common.App.get_pageUUID();
    this.username = auth.getUsername();
		this.status_option = await common.App.arango_app_selections("events", "status");
		
		var types = await common.App.arango_app_selections("events", "type"); // to be filtered by event type
		var type = this.get_component_path(this.pageUUID);
		this.type_option = types.filter(function (recs) {
			return recs.description == type;
		});
		this.event_type = type;

		// Note: get auth-role.
    let res = await common.wBackEndComm.GetData("users/api_get_user_roles/");
    res = res.data;
    if (res.Status == 1) {
      // this.selected.roles = res.Body;
      this.auth_role_list = res.Body;
    } else {
      common.wMsgBox.Error(res.Description);
    }
    this.auth_role = common.App.check_role(this.auth_role_list, 9);

		this.selected._id = common.App.getQueryString("_id");
		if (this.selected._id) {
			await this.refreshData();
		} else {
			// add new records here!
			this.selected.label = this.event_type;
			this.selected.g_status_id = this.status_option[0]._id
			this.selected.status = this.status_option[0].label
		}

		common.App.loader.hide(this);
  },
  computed: {
    comp_membersList: {
      get: function () {
        return this.membersList;
      }
    },
    comp_collaboratorsList: {
      get: function () {
        return this.collaboratorsList;
      }
    }
  },
  methods: {
		newColl (event) {
			this.collaboratorsList = event;
		},
		newMember (event) {
			this.membersList = event;
		},
		epoch2localedatetime: common.App.epoch2LocaleDatetime,
		async refreshData() {
			if (!this.selected._id || this.selected._id==null) {
				return;
			}

			let res = await common.wBackEndComm.GetData("events/events_listing/?_id="+this.selected._id);
      res = res.data
      if (res.Status == 1) {
        this.selected = res.Body[0].records[0];
				this.collaboratorsList = this.selected.collaborators;
				this.membersList = this.selected.data.candidates;
				this.freezedSelected = structuredClone(this.selected); // NOTE: to avoid records amendment when Set-Inactive.
				
				// Note: get event-roles.
        var r = this.selected.collaborators.filter(e => e.username==this.username);
        var len = r.length;
        for (let i = 0; i < len; i++) {
          let len1 = r[i].role.length;
          for (let j = 0; j < len1; j++) {
            if (r[i].role[j].value == true) {
              this.user_event_role.push(r[i].role[j].name);
            }
          }
        }
        this.user_event_role = [...new Set(this.user_event_role)];

			} else {
        common.wMsgBox.Error(res.Description);
      }
				
		},	
		async onClick_save(coll=false) {
			// Note: coll true = update collaborators only.
			if ((!this.auth_role) && (!this.user_event_role.includes('Admin'))) {
				common.wMsgBox.Error("You are not authorized to update this page.");
				this.refreshData();
			}

			switch (this.event_type) {
				case "btrt":
					this.selected.collaborators = this.collaboratorsList;
					this.selected.data.candidates = this.membersList;

					if (this.selected.data.candidates.length == 0) {
						common.wMsgBox.Error("Please add Group and member.");
						return;
					}
					
					let LEN = this.selected.data.candidates.length;
					for (let k = 0; k < LEN; k++) {
						if (this.selected.data.candidates[k].username == undefined) {
							common.wMsgBox.Error("Missing member in Group(s). Please add member to Group(s).");
							return;
						}
					}

					common.App.loader.show(this);
					if (this.$refs.MainForm.validate()) {
						// NOTE: assign status-Draft to new record.

						// if (this.selected._id == null) {
						// 	this.selected.g_status_id = this.status_option[0]["_id"];
						// }
						let new_rec = !this.selected._id;

						let tempRec = {};
						let order = this.getCurrentStatusOrder(this.selected.g_status_id);
						if (order > 2) {
							tempRec = this.freezedSelected;
						} else {
							tempRec = this.selected;
						}

						if (coll) {
							// Note: update collaborators.
							tempRec.collaborators = structuredClone(this.selected.collaborators);
						}

						// Note: add type & status label to meet DB structure.
						tempRec["type"] = this.type_option.filter(e=> e._id == tempRec.g_type_id)[0].label;
						tempRec["status"] = this.status_option.filter(e=> e._id == tempRec.g_status_id)[0].label;

						var url = "events/events_crud/";
						var result = await common.wBackEndComm.PostData(url, tempRec);
						result = result.data;

						if (result.Status == 1) {
							this.selected = result.Body;
							common.wMsgBox.Success(result.Description);

							if (new_rec) {
								window.location.href = "events_crud?uuid=73953984-a422-4608-b430-bc0f91bbcaaa&_id=" + this.selected._id;
							} else {
								this.refreshData();
							}
						} else {
							common.wMsgBox.Error(result.Description);
							// this.refreshData();
						}
					} else {
						common.wMsgBox.Error("Please fill in all required fields before click on save button.");
					}
					common.App.loader.hide(this);
					break;

				case "default":
					break;
			}
		},
		get_component_path(pageUUID) {
			var menu = auth.getMenu().concat(auth.getMenu_int());
			var temp = menu.filter(function (el) {
				return el.uuid == pageUUID;
			});
			return temp[0].component_path.event_type;
		},
		setActive_onClick() {
			this.selected.g_status_id = this.status_option[1]._id;
      this.onClick_save();
    },
    setInactive_onClick() {
      this.freezedSelected.g_status_id = this.status_option[2]._id;
			this.selected.g_status_id = this.status_option[2]._id; // NOTE: to check status when Save records.
			this.onClick_save();
    },
    getCurrentStatusOrder(cur_status_id) {
      var val = null;      
      var obj = this.status_option.find(function(el){
        return el._id==cur_status_id;
      });

      if (obj){
        val = obj.order;
      }

      return val;
    },
	},
};
</script>
